import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AbstractHttpService } from '../../service/http-abstract-service';
import { UserChangePasswordDto, AdminKioskResponseDto, KioskRoleDto, KioskUserDto, KioskCardDispenserStatusDto, KioskDto, KioskPrinterStatusDto, MaintenancePermissionDto, MaintenancePermissionRoleDto, TechnicianPayloadDto } from './dto';


@Injectable({
	providedIn: 'root'
})
export class HttpTechnicianService extends AbstractHttpService {

	constructor(http: HttpClient) {
		super(http, '/technician');
	}

	getAll(): Observable<TechnicianPayloadDto[]> {
		return super.get(`/get`);
	}

	getTechnicianByUsername(username: string): Observable<KioskUserDto> {
		return super.get(`/${username}/get`);
	}

	sendOtp(technicianId: number): Observable<AdminKioskResponseDto> {
		return super.get(`/${technicianId}/send-otp`);
	}

	verifyOtp(technicianId: number, otp: number): Observable<AdminKioskResponseDto> {
		return super.get(`/${technicianId}/${otp}/verify-otp`);
	}

	setPassword(username: string, currentPassword: string, newPassword: string, confirmPassword: string): Observable<AdminKioskResponseDto> {
		let payload: UserChangePasswordDto = {
			newPassword: newPassword,
			currentPassword: currentPassword,
			confirmPassword: confirmPassword
		}
		return super.post(`/${username}/set-password`, payload);
	}

	editTechnician(technician: KioskUserDto, maintenanceRole: MaintenancePermissionRoleDto): Observable<AdminKioskResponseDto> {
		var payload = {
			technician: technician,
			maintenanceRole: maintenanceRole
		}
		return super.post(`/${technician.id}/edit`, payload);
	}

	changeTechnicianStatus(technicianId: number, status: 'Unblock' | 'Disable' | 'ReEnable' | 'Reset'): Observable<AdminKioskResponseDto> {
		return super.get(`/${technicianId}/${status}/action`);
	}

	addTechnician(technician: KioskUserDto, maintenanceRole: MaintenancePermissionRoleDto): Observable<AdminKioskResponseDto> {
		var payload = {
			technician: technician,
			maintenanceRole: maintenanceRole
		}
		return super.post(`/add`, payload);
	}

	doMaintenance(qrData: string): Observable<AdminKioskResponseDto> {
		return super.post(`/maintenance`, qrData);
	}

	getAllMaintenancePermissions(): Observable<MaintenancePermissionDto[]> {
		return super.get(`/get-all-maintenance-permissions`);
	}
	saveMaintenancePermissions(config: MaintenancePermissionDto): Observable<AdminKioskResponseDto> {
		return super.post(`/save-maintenance-permissions`, config);
	}
	getMaintenancePermissionByRole(role: string): Observable<MaintenancePermissionRoleDto[]> {
		return super.get(`/${role}/get-maintenance-permission-by-role`);
	}
	getAllMaintenancePermissionRoles(): Observable<MaintenancePermissionRoleDto[]> {
		return super.get(`/get-all-maintenance-permission-roles`);
	}
	getMaintenanceRoles(): Observable<MaintenancePermissionRoleDto[]> {
		return super.get(`/get-maintenance-roles`);
	}
}
